'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _formatPhoneNumber = require('I18n/utils/formatPhoneNumber');

var _formatPhoneNumber2 = _interopRequireDefault(_formatPhoneNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'FormattedPhoneNumber',

  propTypes: {
    value: _react.PropTypes.string.isRequired
  },

  render: function render() {
    var _props = this.props,
        value = _props.value,
        passThroughProps = _objectWithoutProperties(_props, ['value']);

    return _react2.default.createElement(
      'span',
      passThroughProps,
      (0, _formatPhoneNumber2.default)(value)
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.297/js/components/FormattedPhoneNumber.js
// module id = 343
// module chunks = 0